import { useMemo } from 'react';
import { officeFormSource } from './forms-source.js';
import { useSession } from './session.js';

/**
 * Ofiste ISM form kayıtlarının kaynağı (plan M8b Task 21; ADR 0042 §21): oturumdaki kişiyle
 * kurulur (basan kişi kapakta ve altlıkta); saat UTC. Ofis kaydı yazmaz, yalnız ofis adımına karar
 * verir.
 */
export function useOfficeForms() {
  const session = useSession();
  const user = session.me?.user;
  const name = user?.fullName ?? user?.email ?? '';
  return useMemo(
    () =>
      officeFormSource({ name, place: 'Office', timeZone: null }, `Felixmate ${__APP_VERSION__}`),
    [name],
  );
}
